import { Factory } from 'rosie';

Factory.define('Organization');

Factory.define('OrganizationWithDefaults')
  .extend('Organization')
  .attr('id', 'example-org-id')
  .attr('loginDomain', 'example.com')
  .attr('gladlyUrl', 'https://example.com/gladly')
  .attr('isSidekickEnabled', false);
